// TF Monogram — balanced variant.
// Construction on a 64×64 grid:
//   • Shared crossbar (edge-to-edge, no overhang): x=4→60, y=12→20, thickness 8
//   • T stem: x=18→26, y=20→56
//   • F stem: x=38→46, y=20→56
//   • F middle arm (ends flush with crossbar right edge): x=46→54, y=30→38
// Silhouette reads as a clean rectangle; stems are symmetric around x=32.
//
// Uses currentColor so it inherits from the parent. Size prop sets both
// width and height (always square).
interface Props {
  size?: number | string
  className?: string
  title?: string
}

export function LogoMonogram({ size = 64, className, title }: Props) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <rect x="4" y="12" width="56" height="8" />
      <rect x="18" y="20" width="8" height="36" />
      <rect x="38" y="20" width="8" height="36" />
      <rect x="46" y="30" width="8" height="8" />
    </svg>
  )
}

// Plate: rounded-square icon wrapper with the monogram centered on a solid
// background. Perfect for in-app "app icon" contexts (onboarding, login,
// admin headers). The plate color and glyph color are both consumed from
// Tailwind via bg- / text- utilities on the className.
export function LogoMonogramPlate({
  size = 56,
  className,
}: {
  size?: number
  className?: string
}) {
  const monoSize = Math.round(size * 0.68)
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.28),
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <LogoMonogram size={monoSize} />
    </div>
  )
}
